import months from "../months";
import React from "react";
import sequence from "../sequence";

export default class DateDropDown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.value = props.date;
  }

  onChange() {
    var year = parseInt(this.refs.year.value);
    var month = parseInt(this.refs.month.value);
    var day = parseInt(this.refs.day.value);
    this.value = new Date(year, month - 1, day);

    var { onChange } = this.props;
    if (onChange) {
      onChange(this.value);
    }
  }

  render() {
    var { date } = this.props;
    var monthElems = months.map(month => (
      <option key={month.number} value={month.number}>
        {month.name}
      </option>
    ));
    var dayElems = sequence(1, 32).map(day => (
      <option key={day}>
        {day}
      </option>
    ));

    var now = new Date();
    var currentYear = now.getFullYear();

    var selectedMonth = "- Month -";
    var selectedDay = "- Day -";
    var selectedYear = "- Year -";
    if (date) {
      selectedMonth = date.getMonth() + 1;
      selectedDay = date.getDate();
      selectedYear = date.getFullYear();
    }

    var ageOfOldestPerson = 122;
    var yearElems = sequence(currentYear - ageOfOldestPerson, currentYear + 1).reverse().map(year => (
      <option key={year}>
        {year}
      </option>
    ));
    return (
      <div>
        <div className="form_input form_input--select">
          <select defaultValue={selectedMonth} onChange={this.onChange} ref="month">
            <option disabled>
              - Month -
            </option>

            {monthElems}
          </select>
        </div>

        <div className="form_input form_input--select">
          <select defaultValue={selectedDay} onChange={this.onChange} ref="day">
            <option disabled>
              - Day -
            </option>

            {dayElems}
          </select>
        </div>

        <div className="form_input form_input--select">
          <select defaultValue={selectedYear} onChange={this.onChange} ref="year">
            <option disabled>
              - Year -
            </option>

            {yearElems}
          </select>
        </div>
      </div>
    );
  }
}
